var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWellbeingBkgd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "402px",
    height: "128px",
    viewBox: "0 0 402 128",
    style: {
      enableBackground: "new 0 0 402 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{mask:url(#mask-2_1_);fill:#FFFFFF;}\n\t.st4{filter:url(#Adobe_OpacityMaskFilter_1_);}\n\t.st5{mask:url(#mask-4_1_);fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(2.282723, 3.430769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st0",
    d: "M84.3,89.6c-9.7,0-17.2,7.6-17.2,17.3c0,13.8,14.5,27,36.4,47l1.4,1.3l1.3-1.2 c22-20.1,36.5-33.3,36.5-47.1c0-9.7-7.6-17.3-17.2-17.3c-5.5,0-10.9,2.5-14.5,6.8l-6,7.1l-6-7.1C95.2,92.2,89.7,89.6,84.3,89.6 L84.3,89.6z M104.8,176.6l-11.9-10.9c-25.1-22.9-41.7-37.9-41.7-58.8c0-18.6,14.5-33.2,33.1-33.2c7.3,0,14.6,2.5,20.6,6.8 c6-4.3,13.2-6.8,20.6-6.8c18.6,0,33.1,14.6,33.1,33.2c0,20.8-16.5,35.9-41.5,58.7L104.8,176.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 0.976475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-3-Clipped"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path-1_1_"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: -2.3,
    y: 11.6,
    width: 214.2,
    height: 215
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -2.3,
    y: 11.6,
    width: 214.2,
    height: 215,
    id: "mask-2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1_2_",
    className: "st2",
    points: "-2.3,11.6 211.9,11.6 211.9,226.6 -2.3,226.6  "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "st3",
    d: "M104.8,27.5c-50.3,0-91.2,41.1-91.2,91.6c0,50.5,40.9,91.6,91.2,91.6s91.2-41.1,91.2-91.6 C196.1,68.6,155.1,27.5,104.8,27.5 M104.8,226.6c-59.1,0-107.1-48.2-107.1-107.5c0-59.3,48-107.5,107.1-107.5 s107.1,48.2,107.1,107.5C211.9,178.4,163.9,226.6,104.8,226.6"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group-2_1_",
    transform: "translate(1.549738, 2.323077)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1_1_",
    className: "st0",
    d: "M313,15.7c-6.5,0-11.7,5.1-11.7,11.7c0,9.3,9.8,18.2,24.7,31.7l0.9,0.9l0.9-0.8 c14.9-13.6,24.7-22.5,24.7-31.8c0-6.5-5.1-11.7-11.7-11.7c-3.7,0-7.4,1.7-9.8,4.6l-4.1,4.8l-4.1-4.8 C320.4,17.4,316.7,15.7,313,15.7L313,15.7z M326.9,74.4l-8.1-7.4c-17-15.4-28.2-25.6-28.2-39.7c0-12.6,9.8-22.4,22.4-22.4 c5,0,9.9,1.7,13.9,4.6c4-2.9,9-4.6,13.9-4.6c12.6,0,22.4,9.9,22.4,22.4c0,14.1-11.2,24.2-28.1,39.6L326.9,74.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5_1_",
    transform: "translate(0.000000, 0.661201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-3-Clipped_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path-1_3_"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: 254.5,
    y: -37,
    width: 145,
    height: 145.1
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 254.5,
    y: -37,
    width: 145,
    height: 145.1,
    id: "mask-4_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-3_1_",
    className: "st2",
    points: "254.5,-37 399.5,-37 399.5,108.2 254.5,108.2  "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3_1_",
    className: "st5",
    d: "M327-26.2c-34.1,0-61.8,27.7-61.8,61.8c0,34.1,27.7,61.8,61.8,61.8s61.8-27.7,61.8-61.8 C388.7,1.5,361-26.2,327-26.2 M327,108.2c-40,0-72.5-32.6-72.5-72.6C254.5-4.4,287-37,327-37s72.5,32.6,72.5,72.6 C399.5,75.6,366.9,108.2,327,108.2"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellbeingBkgd);
export default __webpack_public_path__ + "static/media/wellbeing-bkgd.9e7aa3dd49674b8284cd200c6f37729e.svg";
export { ForwardRef as ReactComponent };